import { store } from '../../store'
import { httpgst } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  get ({commit, dispatch}, payload) {
    let searchExpensesId = payload.event.context.searchExpensesId;
    let baseUrl = 'api/expenses-company-status/' + store.state.userLogged.company[0].id + '/4';
    let params = `?status2=5&assignedToMe=1`;

    if (searchExpensesId && searchExpensesId > 0) {
      params += `&expense_id=${searchExpensesId}`;
    } else {
      params += `&start_date=${payload.event.context.startDate}&end_date=${payload.event.context.endDate}`;
    }

    let url = baseUrl + params;

    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetExpenses', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getOthers ({commit, dispatch}, payload) {
    let searchExpensesId = payload.event.context.searchExpensesId;
    let baseUrl = 'api/expenses-company-status/' + store.state.userLogged.company[0].id + '/4';
    let params = `?status2=5&assignedToMe=0`;

    if (searchExpensesId && searchExpensesId > 0) {
      params += `&expense_id=${searchExpensesId}`;
    } else {
      params += `&start_date=${payload.event.context.startDate}&end_date=${payload.event.context.endDate}`;
    }

    let url = baseUrl + params;

    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetOthers', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  updateStatus ({commit, dispatch}, payload) {
    let url = 'api/expenses-change-paid/' + payload.event.expensesId + '/' + payload.event.payment
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.put(url, {}, options)
      .then(
        response => {
          commit('onPutExpenseStatus', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  payExpensesMultipleByAmount({ commit, dispatch }, payload) {
    let url = 'api/expenses-change-paid'

    let params = payload.event.params
    
    let options = { headers: { 'Content-Type': 'application/json' } }
    
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    
    httpgst.post(url, params, options).then(
      response => {
        commit('onPayExpensesMultipleByAmount', {event: payload.event, response: response})
      },
      error => {
        commit('onError', {event: payload.event, error: error})
      }
    )
  },
  downloadLayout ({ commit, dispatch }, payload) {
    let typeDocument = payload.event.typeArchive
    let url = `api${payload.event.url}`
    let params = {expenses: payload.event.listId}
    let config = {}
    let configParams = {}
    if (typeDocument === 'txt' || typeDocument === 'xml') {
      config = { responseType: typeDocument }
    } else {
      configParams = {responseType: 'blob'}
      config = { emulateJSON: false, headers: { 'Content-Type': 'application/vnd.ms-excel' } }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    // Utilizar una función para formatear los parámetros
    const formatParams = (params) => {
      return Object.keys(params)
        .map(key => Array.isArray(params[key]) ? params[key].map(val => `${key}[]=${val}`).join('&') : `${key}=${params[key]}`)
        .join('&')
    }
    // Concatenar los parámetros directamente a la URL
    if (Object.keys(params).length > 0) {
      url += `?${formatParams(params)}`
    }
    httpgst.get(url, configParams, config)
      .then(
        response => {
          commit('onDownloadFilesERPZip', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  }
}

// mutations
const mutations = {
  onGetExpenses (state, payload) {
    let expenses = payload.response.data.data.sort((a, b) => a.id - b.id)
    expenses.forEach(item => { item.isChecked = false })

    const conExpenseExportLog = expenses.filter(item => item.erp_export_log.length > 0)
    const sinExpenseExportLayout = expenses.filter(item => item.erp_export_log.length === 0)
    
    payload.event.context.expenses = sinExpenseExportLayout
    payload.event.context.expensesExportLayout.push(...conExpenseExportLog)
    payload.event.context.loadingDataTableLayout = false
    payload.event.context.loadingDataTable = false
  },
  onGetOthers (state, payload) {
    let expensesOthers = payload.response.data.data.sort((a, b) => b.id - a.id)
    expensesOthers.forEach(item => { item.isChecked = false })
    
    const conExpenseExportLog = expensesOthers.filter(item => item.erp_export_log.length > 0)
    const sinExpenseExportLayout = expensesOthers.filter(item => item.erp_export_log.length === 0)

    payload.event.context.expensesOthers = sinExpenseExportLayout
    payload.event.context.expensesExportLayout.push(...conExpenseExportLog)
    payload.event.context.loadingDataTableLayout = false
    payload.event.context.loadingDataTableOthers = false
  },
  onPayExpensesMultipleByAmount (state, payload) {
    let data = payload.response.data.data
    const hasErrors = Object.values(data).some(item => item.success === false)

    payload.event.context.expensesOthers = sinExpenseExportLayout
    payload.event.context.expensesExportLayout.push(...conExpenseExportLog)

    payload.event.context.loadingItems = false
  },
  onPayExpensesMultipleByAmount (state, payload){
    let data = payload.response.data.data
    const hasErrors = Object.values(data).some(item => item.success === false)
    
    if(hasErrors){
         const finalMessage = payload.event.context.$t('general.errorResponseMultiple') 
                            + " ERROR: " 
                            + Object.keys(data).filter(key => data[key].success === false).map(key => `${data[key].message} ID : ${key}`).join("\n")

        payload.event.context.showNotification(finalMessage, 'error', -1)                                           
    }
    else{
      payload.event.context.showNotification(payload.response.data.message, 'success')
    }
    payload.event.context.downloadLayout()
    payload.event.context.refresh()
    payload.event.context.close()
  },
  onPutExpenseStatus (state, payload) {
    payload.event.context.refresh()
    payload.event.context.close()
    payload.event.context.showNotification(payload.response, 'success')
  },
  onError (state, payload) {
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      if (payload.error.response.status === 500) payload.event.context.showNotification(payload.event.context.$t('general.errorChargeDataByRangeDate'), 'error', -1)
      else payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loadingDownload = false
  },
  onDownloadFilesERPZip (state, payload) {
    if (payload.response.status !== 200) {
      payload.event.context.loadingDownload = false
      payload.event.context.showNotification(payload.response.message, 'error', -1)
      return
    }

    if(payload.event.context.tagSelected !== 2) {
        payload.event.context.expensesExportLayout = []
        payload.event.context.reloadGet()
    }
    payload.event.context.close()
    payload.event.context.forceFileDownload(payload.response.data, `Layout.${payload.event.typeArchive}`)
    payload.event.context.loadingDownload = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/expensesPayable.js